import { createFileRoute } from "@tanstack/react-router";

import Gigs from "@/features/gigs/Gigs";
import SideNavLayout from "@/layouts/SideNavLayout";
import { GigsMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/gigs/")({
  component: () => (
    <SideNavLayout menu={<GigsMenu />}>
      <Gigs />
    </SideNavLayout>
  ),
});
